import { render, staticRenderFns } from "./groupingManagement.vue?vue&type=template&id=496af86a&scoped=true"
import script from "./groupingManagement.vue?vue&type=script&lang=js"
export * from "./groupingManagement.vue?vue&type=script&lang=js"
import style0 from "./groupingManagement.vue?vue&type=style&index=0&id=496af86a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496af86a",
  null
  
)

export default component.exports